import { collection, onSnapshot } from "firebase/firestore";
import { db } from "./ambiente";

/* ============================================================
   Lugares do desafio

   Um documento por lugar, agregado pela função a partir dos pratos. O
   cliente só lê: contar visitas no navegador exigiria baixar o feed
   inteiro só pra montar o guia, e daria números diferentes pra cada
   pessoa dependendo de quantos pratos couberam na consulta dela.
   ============================================================ */

export interface PlaceDoc {
  name: string;
  coords: { lat: number; lng: number } | null;
  visits: number;
  uids: string[];
  thumbPath: string | null;
  ratingSum: number;
  ratingCount: number;
}
export interface Place extends PlaceDoc {
  id: string;
  /** Média das notas dos pratos comidos ali, ou null se ninguém deu nota. */
  rating: number | null;
}

export function watchPlaces(cid: string, cb: (list: Place[]) => void): () => void {
  return onSnapshot(
    collection(db, "challenges", cid, "places"),
    (snap) => {
      const list = snap.docs
        .map((d) => {
          const data = d.data() as PlaceDoc;
          const n = data.ratingCount || 0;
          return { id: d.id, ...data, rating: n ? (data.ratingSum || 0) / n : null };
        })
        // Lugar zerado por uma troca de endereço não aparece mais.
        .filter((p) => (p.visits ?? 0) > 0);
      list.sort((a, b) => (b.visits || 0) - (a.visits || 0));
      cb(list);
    },
    () => cb([]),
  );
}
